import { Button } from '@material-ui/core';
import { React, useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import * as API from '../../api/index';
import { ErrorText, StyledPayPal } from '../../components/styles/global-style';

const ReactPaypal = ({ price, product }) => {
    const [paid, setPaid] = useState(false);
    const [error, setError] = useState(null);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')))


    const paypalRef = useRef();

    useEffect(() => {
        window.paypal.Buttons({
            createOrder: (data, actions) => {
                return actions.order.create({
                    intent: "CAPTURE",
                    purchase_units: [
                        {
                            description: `Payments for ${product}`,
                            amount: {
                                currency_code: 'USD',
                                value: price
                            },
                        },
                    ],
                });
            },
            onApprove: async (dat, actions) => {
                const order = await actions.order.capture();
                var payee = user?.user.username
                var email = user?.user.email
                const paymentData = { user:payee, order, product , email, amount:price}
                const { data } = await API.paypalpay(paymentData)
                setPaid(true);
                console.log(order)
                console.log(data)
            },
            onError: (err) => {
                setError(err)
                console.error(err)
            },
        })
            .render(paypalRef.current);
    }, []);

    if (paid) {
        return <div>Payment Successful.!</div>;
    }

    if (error) {
        return <div>Error occurred in processing payment.! Please try again.</div>;
    }

    return (
        <>
            {user ?
                <StyledPayPal ref={paypalRef} >
                    <h4>Total Amount in USD. {price} /-</h4>

                </StyledPayPal>
                : <Button component={Link} to='/auth'><ErrorText>Log in first !</ErrorText></Button>
            }

        </>
    )
}

export default ReactPaypal